import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FetaureGrouper } from '@core/models/piramide/FeatureGrouper';
import { Product } from '@core/models/piramide/Product';
import { ProductDetails } from '@core/models/piramide/ProductDetails';
import { PiramidalService } from '@core/services/piramidal.service';
import { environment } from '@environments/environment';
import { ProductsService } from '@core/services/products.service';
import { catchError, combineLatest, of } from 'rxjs';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ProductCharacteristicTypePipe } from '@core/pipes/product-characteristic-type.pipe';
import { SpinnerComponent } from '@core/components/spinner/spinner.component';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'cgw-modal-armado',
  templateUrl: './modal-armado.component.html',
  styleUrls: ['./modal-armado.component.scss'],
  standalone: true,
  imports: [
    SpinnerComponent,
    MaterialModule,
    TitleCasePipe,
    ProductCharacteristicTypePipe,
    CommonModule,
  ],
})
export class ModalArmadoComponent implements OnInit {
  infoMostrarCpu: any = null;
  infoMostrarMother: any = null;
  infoMostrarCcpu: any = null;
  infoMostrarMemoria: any = null;
  nombreImagen: string;
  loading: boolean;
  absolutePath: boolean;
  product: ProductDetails;
  specifications: FetaureGrouper[];
  assetsImage = environment.assetsImage;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { categoria: number; producto: Product; alertaPlaca: boolean },
    public dialogRef: MatDialogRef<ModalArmadoComponent>,
    private piramide: PiramidalService,
    private productService: ProductsService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.getData(this.data);
  }

  private getData(data: { categoria: number; producto: Product; alertaPlaca: boolean }): void {
    if (!data.producto) {
      return;
    }
    combineLatest([
      this.piramide.ProductDetails.getByIndex([data.producto.id_producto]).pipe(
        catchError((e) => of([] as ProductDetails[])),
      ),
      this.piramide.FetaureGrouper.observable.pipe(catchError((e) => of([] as FetaureGrouper[]))),
    ]).subscribe((observables) => {
      this.product = observables[0][0];
      if (this.product && observables[1].length) {
        const caracteristicas = this.product.caracteristicas;
        if (caracteristicas) {
          this.specifications = this.productService.getCaract(caracteristicas, observables[1]);
          this.specifications.sort((a, b) => {
            if (a.orden < b.orden) return -1;
            if (a.orden > b.orden) return 1;
            else {
              if (a.id > b.id) return 1;
              else if (a.id < b.id) return -1;
              return 0;
            }
          });
          console.log(this.specifications);
          this.loading = false;
        } else {
          this.specifications = [];
          this.loading = false;
        }
      } else {
        this.specifications = [];
        this.loading = false;
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
